<template>
	<x-modal
		:wWidth="1080"
		v-if="isVisible"
		@cancel="closeModal()"
		@close="closeModal()"
		@ok="saveTask(true)"
		:draggable="true"
		:resizable="true"
		:loading="loading"
		:okDisabled="loading"
		:okText="create ? 'Create Task' : 'Update Task'"
		:hideOkSecondary="create ? true : false"
		okSecondaryType="danger"
		okSecondaryText="Delete Task"
		@okSecondary="deleteTask()"
	>
		<div slot="title" :class="`d-flex justify-content-between align-items-center`">
			{{ this.create ? "Create" : "Update" }} Task
		</div>

		<el-form ref="taskForm" :model="taskForm" :rules="taskFormRules" label-position="left" label-width="200">
			<el-form-item prop="taskable_type" label="Related To">
				<small style="float: right">
					Search for an application by ID, search for a broker or contact by name or type 'me' to assign to yourself
				</small>
				<el-select
					:key="taskForm.taskable_object.value"
					class="w-100"
					v-model="taskForm.taskable_object"
					filterable
					remote
					reserve-keyword
					placeholder="Enter your keyword"
					:remote-method="relatedToSearch"
					:loading="relatedLoading"
				>
					<el-option-group v-for="group in relatedData" :key="group.label" :label="group.label">
						<el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item"></el-option>
					</el-option-group>
				</el-select>
			</el-form-item>

			<el-form-item prop="broker_id" label="Assign To">
				<el-select class="w-100" v-model="taskForm.broker_id" placeholder="Assign To">
					<el-option v-for="item in brokerUsers" :key="item.id" :label="item.full_name" :value="item.id"></el-option>
				</el-select>
			</el-form-item>

			<el-form-item prop="task_name" label="Task Name">
				<el-input v-model="taskForm.task_name"></el-input>
			</el-form-item>

			<el-row :gutter="10">
				<el-col :span="12">
					<el-form-item prop="due_date" label="Due Date">
						<el-date-picker
							class="w-100"
							v-model="taskForm.due_date"
							type="date"
							placeholder="Due Date"
							format="dd/MM/yyyy"
							:picker-options="options.pickerOptions"
						></el-date-picker>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item prop="time" label="Due Time">
						<el-time-picker
							class="w-100"
							default-value="17:00:00"
							value-format="HH:mm:ss"
							v-model="taskForm.time"
							placeholder="Due Time"
						></el-time-picker>
					</el-form-item>
				</el-col>

				<el-col :span="24">
					<el-form-item prop="status_id" label="Task Status">
						<el-select :disabled="create" class="w-100" v-model="taskForm.status_id" placeholder="Task Status">
							<el-option
								v-for="status in taskStatuses"
								:key="status.value"
								:label="status.label"
								:value="status.value"
							></el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
	</x-modal>
</template>

<script>
	import { mapGetters } from "vuex"
	export default {
		name: "CreateTaskModal",
		props: {
			visible: {
				required: true,
				type: Boolean,
			},
			create: {
				required: true,
				type: Boolean,
			},
			task: {
				required: false,
				type: Object,
			},
			applicationId: {
				required: false,
				type: [String, Number],
			},
		},
		computed: {
			...mapGetters({
				user: "user/user",
			}),
		},
		data() {
			return {
				teamId: null,
				isVisible: false,
				loading: false,
				brokersLoading: true,
				relatedLoading: false,
				relatedTimeout: null,
				relatedTimeoutWait: 1500,
				relatedData: [],
				brokerUsers: [],
				taskForm: {
					due_date: this.$moment(),
					time: "17:00:00",
					status_id: 1,
					taskable_object: {},
					taskable_id: null,
					taskable_type: "",
					taskable_label: "",
					broker_id: null,
				},
				taskFormRules: {
					taskable_type: [{ required: true, message: "Related To is Required", trigger: "change" }],
					broker_id: [{ required: true, message: "Assign To is Required", trigger: "change" }],
					task_name: [{ required: true, message: "Task Name is Required", trigger: "blur" }],
					due_date: [{ required: true, message: "Task Due Date is Required", trigger: "blur" }],
					time: [{ required: true, message: "Task Due Time is Required", trigger: "blur" }],
				},
				options: {
					pickerOptions: {
						disabledDate(time) {
							return time.getTime() < Date.now() - 3600 * 1000 * 24
						},
						shortcuts: [
							{
								text: "Today",
								onClick(picker) {
									picker.$emit("pick", new Date())
								},
							},
							{
								text: "Tomorrow",
								onClick(picker) {
									const date = new Date()
									date.setTime(date.getTime() + 3600 * 1000 * 24)
									picker.$emit("pick", date)
								},
							},
							{
								text: "Next Week",
								onClick(picker) {
									const date = new Date()
									date.setTime(date.getTime() + 3600 * 1000 * 24 * 7)
									picker.$emit("pick", date)
								},
							},
						],
					},
				},
				taskStatuses: [
					{
						label: "Open",
						value: 1,
					},
					{
						label: "Closed",
						value: 2,
					},
				],
			}
		},

		mounted() {
			this.teamId = _.get(Ambition, "Globals.tenant.user.current_team_id")
			this.getBrokersList()
		},

		methods: {
			saveTask() {
				this.$refs["taskForm"].validate((valid) => {
					if (valid) {
						this.loading = true
						let data = {
							form: this.taskForm,
							user: this.user,
						}

						this.$store.dispatch("tasks/saveTask", data).then((res) => {
							this.loading = false
							this.closeModal()
						})
					}
				})
			},
			deleteTask() {
                let data = {
                    form: this.taskForm,
                    applicationId: this.applicationId,
                }
				swal({
					title: "Are you sure?",
					type: "warning",
					text: "Are you sure you want to delete this task?",
				}).then((res) => {
					if (res.value) {
						this.$store.dispatch("tasks/deleteTask", data)
						this.closeModal()
					}
				})
			},
			relatedToSearch(search) {
				if (this.relatedTimeout) clearTimeout(this.relatedTimeout)

				if (search !== "") {
					this.relatedLoading = true
					this.taskForm.taskable_id = null
					this.taskForm.taskable_type = ""
					this.relatedTimeout = setTimeout(() => {
						this.$tenant
							.post("/api/tasks/v2/get-related-to",{
                                search: search })
							.then((res) => {
								this.relatedData = res.data
								if (_.size(res.data) == 1 && _.size(res.data[0].options) == 1) {
									this.taskForm.taskable_object = res.data[0].options[0]
									this.taskForm.taskable_id = res.data[0].options[0].value
									this.taskForm.taskable_type = res.data[0].options[0].type
									this.taskForm.taskable_label = res.data[0].options[0].label
								}
								let taskForm = this.$refs["taskForm"]
								if (typeof taskForm !== "undefined") {
									taskForm.validateField("taskable_type")
								}
							})
							.catch((err) => {
								console.error(err)
							})
							.finally((res) => {
								this.relatedLoading = false
							})
					}, this.relatedTimeoutWait)
				}
			},
			closeModal() {
				this.loading = false
				this.isVisible = false
				this.relatedData = []
				this.taskForm = {
					due_date: this.$moment(),
					time: "17:00:00",
					status_id: 1,
					taskable_object: {},
					taskable_id: null,
					taskable_type: "",
					taskable_label: "",
					broker_id: this.taskForm.broker_id,
				}
				this.$emit("update:visible", false)
				this.$emit("update:create", true)
				this.$bus.$emit("close-create-modal", "")
			},
			getBrokersList() {
				this.brokersLoading = true
				this.$tenant
					.get(`/api/v2/brokers`, {
						teamId: this.teamId
					})
					.then((res) => (this.brokerUsers = res.data))
					.catch((err) => console.error(err))
					.finally(() => (this.brokersLoading = false))
			},
		},
		watch: {
			visible: {
				handler() {
					this.isVisible = this.visible
					if (this.visible) {
                        if (!_.get(this.task, 'id')) {
                            if (this.applicationId) {
                                this.relatedToSearch(this.applicationId)
                            } else {
                                this.relatedToSearch("me")
                            }
                        }
					}
				},
				deep: true,
				immediate: true,
			},
			task: {
				handler() {
					if (!this.create) {
						this.taskForm = this.task
					} else {
						this.taskForm.due_date = _.get(this.task, "due_date", this.$moment())
						let time = _.get(this.task, "time", "17:00:00")
						this.taskForm.time = time == "00:00:00" ? "17:00:00" : time
					}
				},
				immediate: true,
				deep: true,
			},
			brokerUsers: {
				handler() {
					if (this.create) {
						this.taskForm.broker_id = _.get(
							this.brokerUsers.find((broker) => broker.id === this.user.id),
							"id",
							null
						)
					}
				},
				immediate: true,
				deep: true,
			},
			create: {
				handler() {
					if (!this.create) {
						this.relatedData = [
							{
								label: _.upperFirst(this.taskForm.taskable_related),
								options: [this.taskForm.taskable_object],
							},
						]
					}
				},
				immediate: true,
			},
			"taskForm.taskable_object": {
				handler(taskableObject) {
					this.taskForm.taskable_id = _.get(taskableObject, "value", null)
					this.taskForm.taskable_type = _.get(taskableObject, "type", null)
					let taskForm = this.$refs["taskForm"]
					if (typeof taskForm !== "undefined") {
						taskForm.validateField("taskable_type")
					}
				},
				deep: true,
				immediate: true,
			},
		},
	}
</script>

<style lang="scss" scoped>
</style>
